import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mentorTip: {
    margin: "24px 0px 0px 0px",
  },
  editIconClass: {
    width: "16px",
    height: "24px",
  },
  goalIconClass: {
    width: "32px",
    height: "32px",
  },
  tabTitle: {
    color: "#666666",
    fontSize: theme.typography.pxToRem(16),
    fontStyle: "normal",
    fontFamily: "Lato",
    fontWeight: 400,
    paddingLeft: "4px",
  },
  tabIcon: {
    paddingTop: "6px",
    color: "red",
  },
  tabItemContainer: {
    cursor: "pointer",
    marginRight: "56px",
    marginTop: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .Mui-selected": {
      borderBottom: "3px solid #000000",
    },
  },
}));
